import { addAlert } from "../MsgNotify/msgNotifyActions";
import { httpGet, httpPost, httpPut } from "../Util/http";

export const GET_DEPARTMENTS_REQUEST = "GET_DEPARTMENTS_REQUEST";
export function getDepartmentsRequest() {
  return {
    type: GET_DEPARTMENTS_REQUEST,
  };
}

export const GET_DEPARTMENTS_SUCCESS = "GET_DEPARTMENTS_SUCCESS";
export function getDepartmentsSuccess(json) {
  return {
    type: GET_DEPARTMENTS_SUCCESS,
    departments: json,
  };
}

export const GET_DEPARTMENTS_FAILURE = "GET_DEPARTMENTS_FAILURE";
export function getDepartmentsFailure() {
  return {
    type: GET_DEPARTMENTS_FAILURE,
  };
}

export function attemptGetDepartments() {
  return (dispatch, getState) => {
    // var skip = getState().departmentReducer.departments.length;
    var _url = process.env.REACT_APP_webApiEndPoint + `api/department`;
    dispatch(getDepartmentsRequest());
    return httpGet(_url)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch(getDepartmentsSuccess(json));
      })
      .catch(() => {
        dispatch(getDepartmentsFailure());
        dispatch(addAlert("Kunne ikke hente afdelinger"));
      });
  };
}

export const CREATE_DEPARTMENT_REQUEST = "CREATE_DEPARTMENT_REQUEST";
export function createDepartmentRequest(department) {
  return {
    type: CREATE_DEPARTMENT_REQUEST,
    department: department,
  };
}

export const CREATE_DEPARTMENT_SUCCESS = "CREATE_DEPARTMENT_SUCCESS";
export function createDepartmentSuccess(departmentId, acks) {
  return {
    type: CREATE_DEPARTMENT_SUCCESS,
    departmentId: departmentId,
    acks,
  };
}

export const CREATE_DEPARTMENT_FAILURE = "CREATE_DEPARTMENT_FAILURE";
export function createDepartmentFailure() {
  return {
    type: CREATE_DEPARTMENT_FAILURE,
  };
}

export function attemptCreateDepartment(departmentName, acks) {
  var _url = process.env.REACT_APP_webApiEndPoint + "api/department/create";
  return (dispatch) => {
    if (departmentName.toLowerCase() === "tilbud") {
      dispatch(addAlert("Afdeling kan ikke oprettes med navnet tilbud"));
      return;
    }
    dispatch(
      createDepartmentRequest({
        id: "randomId",
        name: departmentName,
        favorite: true,
      })
    );
    return httpPost(_url, { name: departmentName })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch(createDepartmentSuccess(json, acks));
        return json;
      })
      .then((id) => {
        dispatch(updateActivities(id, acks));
      })
      .catch(() => {
        dispatch(createDepartmentFailure());
        dispatch(addAlert("Kunne ikke oprette afdeling"));
      });
  };
}

export const EDIT_DEPARTMENT_REQUEST = "EDIT_DEPARTMENT_REQUEST";
export function editDepartmentRequest(newDepartmentName, departmentIndex) {
  return {
    type: EDIT_DEPARTMENT_REQUEST,
    departmentName: newDepartmentName,
    departmentIndex: departmentIndex,
  };
}

export const EDIT_DEPARTMENT_SUCCESS = "EDIT_DEPARTMENT_SUCCESS";
export function editDepartmentSuccess() {
  return {
    type: EDIT_DEPARTMENT_SUCCESS,
  };
}

export const EDIT_DEPARTMENT_FAILURE = "EDIT_DEPARTMENT_FAILURE";
export function editDepartmentFailure(oldDepartmentName, departmentIndex) {
  return {
    type: EDIT_DEPARTMENT_FAILURE,
    departmentName: oldDepartmentName,
    departmentIndex: departmentIndex,
  };
}

export const REMOVE_ACK = "REMOVE_ACK";
export function removeAck(departmentIndex, ackIndex, ackName) {
  if (ackName === "Diverse") return;
  return {
    type: REMOVE_ACK,
    ackIndex,
    departmentIndex,
    ackName,
  };
}

export const ADD_ACK = "ADD_ACK";
export function addAck(departmentIndex, ackName) {
  return {
    type: ADD_ACK,
    departmentIndex,
    ackName,
  };
}

export function attemptEditDepartment(
  departmentId,
  newDepartmentName,
  oldDepartmentName,
  departmentIndex,
  acks
) {
  var _url = process.env.REACT_APP_webApiEndPoint + "api/department/update";
  return (dispatch) => {
    //if the new departmentname is empty do nothing.
    if (!newDepartmentName) {
      return;
    } else if (newDepartmentName.toLowerCase() === "tilbud") {
      dispatch(addAlert("Afdeling må ikke navngives tilbud"));
      return;
    }

    dispatch(editDepartmentRequest(newDepartmentName, departmentIndex));
    return httpPut(_url, { id: departmentId, name: newDepartmentName })
      .then(() => {
        dispatch(editDepartmentSuccess());
      })
      .then(() => {
        dispatch(updateActivities(departmentId, acks));
      })
      .catch(() => {
        dispatch(editDepartmentFailure(oldDepartmentName, departmentIndex));
        dispatch(addAlert("Kunne ikke redigere afdeling"));
      });
  };
}

export function updateActivities(departmentId, acks) {
  var _url = process.env.REACT_APP_webApiEndPoint + "api/department/update2";
  return (dispatch) => {
    return httpPut(_url, { id: departmentId, acks: acks })
      .then(() => {})
      .catch(() => {});
  };
}

export const TOGGLE_FAVORITE_DEPARTMENT = "TOGGLE_FAVORITE_DEPARTMENT";
export const toggleFavoriteDeparment = (departmentIndex, favorite) => {
  return {
    type: TOGGLE_FAVORITE_DEPARTMENT,
    departmentIndex: departmentIndex,
    favorite: favorite,
  };
};

export const SET_SHOW_FAVORITES = "SET_SHOW_FAVORITES";
export const setShowFavorites = (showFavorites) => {
  return {
    type: SET_SHOW_FAVORITES,
    showFavorites: showFavorites,
  };
};

export function attemptUpdateFavorite(
  departmentIndex,
  deparpartmentId,
  favorite
) {
  var _url =
    process.env.REACT_APP_webApiEndPoint +
    "api/user/department/favorite/" +
    deparpartmentId;
  return (dispatch) => {
    dispatch(toggleFavoriteDeparment(departmentIndex, favorite));
    return httpPut(_url).catch(() => {
      dispatch(toggleFavoriteDeparment(departmentIndex, !favorite));
    });
  };
}



// WEBPACK FOOTER //
// ./src/App/Department/actions.js